export const locales = ['fi', 'sv', 'en'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'fi';

export const localeLabels: Record<Locale, string> = {
  fi: 'Suomi',
  sv: 'Svenska',
  en: 'English',
};

export function isLocale(value: string | undefined | null): value is Locale {
  return !!value && locales.includes(value as Locale);
}
